module.exports = __webpack_public_path__ + "static/media/logo.39d75b54.svg";